import { Container, injectable, Newable, ServiceIdentifier } from 'inversify';

export const defaultContainer = new Container();

export function Provide<T>(token?: ServiceIdentifier) {
	return (target: Newable<T>) => {
		// eslint-disable-next-line security/detect-possible-timing-attacks
		if (token == null) {
			defaultContainer.bind(target).toSelf();
		} else {
			defaultContainer.bind(token).to(target);
		}
		return injectable()(target);
	};
}

export function Singleton<T>() {
	return (target: Newable<T>) => {
		defaultContainer.bind(target).toSelf().inSingletonScope();
		return injectable()(target);
	};
}
